import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { notification } from '../models/interfaces/notifications';
import { NotificationService } from '../services/notification-service';
import { GlobalService } from '../services/global.service';
import { AlertComponent } from '../common/alert/alert.component';


@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

  notifications: notification[] = [];
  todayDate: Date;
  yesterdayDate: Date;
  todaysNotification: notification[] = [];
  yesterdaysNotification: notification[] = [];
  olderNotification: notification[] = [];
  isLoading = false;
  loadedAll = false;
  isFirstLoad = true;

  constructor(
    public dialogRef: MatDialogRef<NotificationComponent>,
    public notificationService: NotificationService,
    public globalsService: GlobalService,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.todayDate = new Date();
    this.yesterdayDate = new Date(Date.now() - 864e5); //864e5 is 24 hrs
    this.notificationService.setFirstPage();
    this.handleScroll();
    this.getNotifications();
  }

  getNotifications() {
    this.isLoading = true;
    this.notificationService.getBatchNotification().subscribe((data: any): void => {
      if (data.Notifications?.length) {
        this.notifications.push(...data.Notifications);
        this.daywiseNotifications(this.notifications);
      } else {
        this.loadedAll = true;
      }
      this.isLoading = false;
      this.isFirstLoad = false;
    }, (error: Error) => {
        this.globalsService.showAlert(AlertComponent, { success: false, message: "Error in fetching Notification List" });
      this.isLoading = false;
    });
  }

  handleScroll(): void {
    document.getElementById("modelBody").onscroll = () => this.detectBottom();
  }

  detectBottom(): void {
    if (document.getElementById("modelBody").scrollTop >= 295) {
      if (!this.loadedAll) {
        this.notificationService.paginatePage();
        this.getNotifications();
      }
    }
  }

  daywiseNotifications(notifications) {
    this.todaysNotification = notifications.filter(e => new Date(e.time).setHours(0, 0, 0, 0) == this.todayDate.setHours(0, 0, 0, 0));
    this.yesterdaysNotification = notifications.filter(e => new Date(e.time).setHours(0, 0, 0, 0) == this.yesterdayDate.setHours(0, 0, 0, 0));
    this.olderNotification = notifications.filter(e => new Date(e.time).setHours(0, 0, 0, 0) < this.yesterdayDate.setHours(0, 0, 0, 0));
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }
}
